// extracted by mini-css-extract-plugin
module.exports = {"title":"GraphHeader_title__3Js2D","subTitle":"GraphHeader_subTitle__191PJ"};